import React from 'react'
import classNames from 'classnames';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ReactTooltip from 'react-tooltip'
import { FaInfoCircle } from 'react-icons/fa';

import BATTERY_CONFIG from '../config/BatteryRadio.json'

const BatteryOption = props => (
    <div className="form-input-container">
        <div>
            <b>Battery Fire Simulation Option</b><FaInfoCircle data-tip data-for="pollutant-info"/>

            <ReactTooltip id='pollutant-info' place="right" type="light" effect="solid">
                Select the species for the simulation.
            </ReactTooltip>
        </div>

        <RadioGroup row key="batteryOption" className={classNames(props.classes.margin, props.classes.textField)}>
            {BATTERY_CONFIG.batteryOption.map(option => (
                <FormControlLabel
                    key={option.value}
                    control={
                        <Radio
                            name={option.value}
                            checked={props.batteryoption === option.value}
                            onChange={props.handleInputChange}
                            value={option.value}
                            inputProps={{radioname:"batteryoption"}}
                            color="primary"/>
                    }
                    label={option.label}/>
            ))}
        </RadioGroup>
    </div>
)

export default BatteryOption;
